import { Box, HStack, Icon, IconButton, Shadow, Stack, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { LogoWithNameLoading } from '../TransferRequestsItem/components/LogoWithName';

export const SkeletonItemMobile: React.FC = () => {
  return (
    <Stack
      px={Utils.Responsive.All({
        desktop: 'inline.xxxs',
        tablet: 'inline.xxs',
        phone: 0,
      })}>
      <Shadow level={1} p="inset.xs" borderRadius={BoxBorder.heavy}>
        <VStack space="stack.xxxs">
          <HStack justifyContent="space-between" alignItems="center">
            <VStack space="stack.quarck" w="1/3">
              <Text>De</Text>
              <LogoWithNameLoading />
            </VStack>
            <Icon name="ArrowRight" size="xs" color="neutral.light" />
            <VStack space="stack.quarck" w="1/3">
              <Text>Para</Text>
              <LogoWithNameLoading />
            </VStack>
          </HStack>
          <VStack space="stack.quarck">
            <HStack justifyContent="space-between">
              <Text>Solicitado via</Text>
              <TextSkeleton w="1/4" />
            </HStack>
            <Box h="1px" w="full" bg="neutral.lightest" />
            <HStack justifyContent="space-between">
              <Text>Data de solicitação</Text>
              <TextSkeleton w="1/4" />
            </HStack>
            <Box h="1px" w="full" bg="neutral.lightest" />
            <HStack justifyContent="space-between">
              <Text>Protocolo</Text>
              <TextSkeleton w="1/4" />
            </HStack>
          </VStack>
          <HStack justifyContent="space-between" alignItems="center">
            <Stack w="1/2">
              <StatusSkeleton />
            </Stack>
            <IconButton
              alignSelf="flex-end"
              testId="details-icon-button"
              icon="ArrowRight"
              disabled
              p={0}
              iconColor="neutral.medium"
              iconSize="xs"
            />
          </HStack>
        </VStack>
      </Shadow>
    </Stack>
  );
};
